// components/PDFContent.js
import { Page, Document, View, Text, StyleSheet, Image } from "@react-pdf/renderer";
import { money } from "~hooks/useHelpers";
import votorantimcimentos from "../../../../assets/images/brand/votorantimcimentos.png";
import votorantim from "../../../../assets/images/brand/votorantim.png";
import useHeader from "~components/Header/hooks/useHeader";
import { mask } from "remask";
import useUsuario from "~fetchs/useUsuario";
import useSimulacao from "~fetchs/useSimulacao";
import { useEffect, useState } from "react";
import useCliente from "~fetchs/useCliente";

// const styles = StyleSheet.create({
//   page: { padding: 30 },
//   section: { marginBottom: 10 },
//   header: { fontSize: 18, marginBottom: 10 },
//   table: { display: "flex", flexDirection: "column", width: "100%" },
//   row: { flexDirection: "row", borderBottomWidth: 1, padding: 5 },
//   cell: { flex: 1, fontSize: 10 }
// });

const styles = StyleSheet.create({
  page: { paddingLeft: 0, paddingRight: 0 },
  section: { marginBottom: 10, paddingLeft: 5, paddingRight: 5 },
  header: { fontSize: 18, marginBottom: 10 },
  table: { display: "flex", flexDirection: "column", width: "100%" },
  row: { flexDirection: "row", borderBottomWidth: 1, padding: 5 },
  cell: { flex: 1, fontSize: 9, marginTop: 12, marginBottom: 12, textAlign: 'center', fontWeight: 'bold' },
  city: { flex: 1, fontSize: 9, marginTop: 12, marginBottom: 12, fontWeight: 'bold' },
  infoTitle: {
    color: "#1002C2",
    marginTop: 8,
    marginLeft: "4rem",
    fontSize: 12,
  },
  cellProduto: {
  width: "130px",
  fontSize: 9,
  marginTop: 12,
  marginBottom: 12,
  textAlign: 'center',
  fontWeight: 'bold'
},
  columnsContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginVertical: 10,
    borderColor: "#1002C2",
  },
  column: {
    flexDirection: "column",
    paddingHorizontal: 16,
    borderRightWidth: 1,
    borderRightColor: "#1002C2",
    minWidth: 200,
  },
  lastColumn: {
    borderRightWidth: 0,
  },
  textGray: {
    color: "#7F7F81",
    fontSize: 10,
    marginVertical: 2,
  },
  boldBlue: {
    color: "#1002C2",
    fontWeight: "bold",
    fontSize: 10,
  },
  footerx: {
    backgroundColor: "#1002C2",
    padding: 16,
    marginTop: 20,
    alignItems: "center",
  },
  headerx: {
    backgroundColor: "#1002C2",
    padding: 5,

    // alignItems: 'center'
  },

  headerRow: { backgroundColor: '#E5E7EB', fontWeight: 'bold',   borderTopLeftRadius: 10,
    borderTopRightRadius: 10 },
  conditionsText: {
    color: "#FFAC78",
    marginTop: 8,
    fontSize: 10,
  },
  infosVendedor: {
    display: "flex",
    justifyContent: "center",
  },
  infoDescVendedor: { fontSize: 10, marginTop: '3px' },
  infoDescVendedorDestaque: { fontSize: 10, fontWeight: 'bold', color: '#1002C2' },
  additionalInfoContainer: {
    flexDirection: "row",
    justifyContent: "center",
    marginVertical: 10,
    borderColor: "#1002C2",
    maxWidth: 700,
    alignSelf: "center"
  },
  additionalInfoColumn: {
    flexDirection: "column",
    paddingHorizontal: 16,
    borderRightWidth: 1,
    borderRightColor: "#1002C2",
    minWidth: 200,
  },
  additionalInfoLastColumn: {
    borderRightWidth: 0,
  },
  conditionsRedText: {
    color: "#FF0707",
    marginTop: 8,
    fontSize: 10,
  },

});

const getTodayDate = () => {
  const date = new Date();
  const months = [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro",
  ];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} de ${month} de ${year}`;
};

export const PDFContent = ({ grupos, values, calcCifModal,calcCif, todosOsProdutos, simulacao, cliente, usuario, searchDias, prazoRegras, prazoPagamentos }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.headerx}>
        <Image src={votorantim} style={{ width: 120 }} />
      </View>


      <View style={styles.section}>
        <Text style={styles.city}>São Paulo, {getTodayDate()}</Text>
      </View>
      <View style={styles.columnsContainer}>
        <View style={styles.column}>
          <Text style={styles.infoDescVendedorDestaque}>
            {simulacao?.nome ? `${simulacao.nome} - ${simulacao.codigo}` : `${cliente?.nome} - ${cliente?.codigo}`}
          </Text>
          <Text style={styles.infoDescVendedor}>
            {simulacao?.grupoCentralizador && simulacao.grupoCentralizador !== 'Sem Grupo Centralizador' ? simulacao.grupoCentralizador : '-'}
          </Text>
          <Text style={styles.infoDescVendedor}>
            {cliente?.endereco?.cidade?.nome || '-'}
          </Text>
        </View>
        <View style={[styles.column, styles.lastColumn]}>
          <Text style={styles.infoDescVendedor}>{usuario?.nome || 'Vendedor Não encontrado'}</Text>
          <Text style={styles.infoDescVendedor}>{usuario?.email || 'Email não encontrado'}</Text>
          <Text style={styles.infoDescVendedor}>{usuario?.telefone || '-'}</Text>
        </View>
      </View>

      <View style={styles.section}>
        <Text style={styles.conditionsText}>
          {values?.fracionario && values?.descarga
            ? "Preços posto-obra com frete, descarga e fracionamento inclusos"
            : values?.fracionario
            ? "Preços posto-obra com frete e fracionamento inclusos"
            : values?.descarga
            ? "Preços posto-obra com frete e descarga inclusos"
            : ""}
        </Text>
      </View>
      <View style={styles.section}>
        <View style={styles.table}>
          <View style={[styles.row, styles.headerRow]}>
            <Text style={styles.cellProduto}>Produto</Text>
            <Text style={styles.cell}>Código do Material</Text>
            <Text style={styles.cell}>Quantidade</Text>
            <Text style={styles.cell}>Preço Unitário</Text>
            <Text style={styles.cell}>Prazo de Pagamento</Text>
            <Text style={styles.cell}>Total</Text>
          </View>
          {todosOsProdutos?.map((produto, idx) => {
             const pzPagamento = prazoPagamentos?.find((p) => p.id === produto.prazoPagamentoId);
            return (

                <View key={idx} style={[styles.row, idx % 2 === 0 ? { backgroundColor: 'white' } : { backgroundColor: '#DDEBF7' }]}>
                  <Text style={styles.cellProduto}>{produto?.produto ?? 'Não encontrado'}</Text>
                  <Text style={styles.cell}>{produto?.codigo ?? 'Não encontrado'}</Text>
                  <Text style={styles.cell}>{produto.quantidade || 1}</Text>
                  <Text style={styles.cell}>{calcCifModal(produto.precoFinal?.cif, produto)}</Text>
                  <Text style={styles.cell}>{pzPagamento ? pzPagamento.nome : searchDias(produto?.produtoOriginal.familiaId , prazoRegras)}</Text>
                  <Text style={styles.cell}>{calcCif(produto.precoFinal?.cif, produto.quantidade || 1, produto)}</Text>
                </View>

            )
          } )}
        </View>
      </View>
      <View style={styles.section}>
        <Text style={styles.infoTitle}>Informações Adicionais</Text>

        <View style={styles.additionalInfoContainer}>
          {/* Primeira Coluna */}
          <View style={styles.additionalInfoColumn}>
            <Text style={styles.textGray}>Sacaria 50 kg</Text>
            <Text style={styles.textGray}>Sacaria 40 Kg</Text>
            <Text style={styles.textGray}>Sacaria 20 Kg</Text>
            <Text style={styles.textGray}>Cales</Text>
            <Text style={styles.textGray}>Rejuntes</Text>
            <Text style={styles.textGray}>Carga Fechada</Text>
            <Text style={styles.textGray}>Carga mínima de agregados</Text>
            <Text style={styles.textGray}>Aditivos 1L</Text>
            <Text style={styles.textGray}>Aditivos 3,6L</Text>
            <Text style={styles.textGray}>Aditivos 18L</Text>
          </View>

          {/* Segunda Coluna */}
          <View style={styles.additionalInfoColumn}>
            <Text style={styles.textGray}>Lote mínimo 40 sacos</Text>
            <Text style={styles.textGray}>Lote mínimo 50 sacos</Text>
            <Text style={styles.textGray}>Lote mínimo 20 sacos</Text>
            <Text style={styles.textGray}>Lote mínimo 13 sacos</Text>
            <Text style={styles.textGray}>Lote mínimo 20 kg</Text>
            <Text style={styles.textGray}>14 toneladas</Text>
            <Text style={styles.textGray}>14 toneladas</Text>
            <Text style={styles.textGray}>Lote mínimo caixa com 8 UND</Text>
            <Text style={styles.textGray}>Lote mínimo caixa com 4 UND</Text>
            <Text style={styles.textGray}>Balde individual 18L</Text>
          </View>

          {/* Terceira Coluna */}
          <View style={[styles.additionalInfoColumn, styles.additionalInfoLastColumn]}>
            <Text style={styles.textGray}>Entregas de múltiplos de 40</Text>
            <Text style={styles.textGray}>Entregas de múltiplos de 50</Text>
            <Text style={styles.textGray}>Entregas de múltiplos de 20</Text>
            <Text style={styles.textGray}>Entregas de múltiplos de 13</Text>
            <Text style={styles.textGray}>-</Text>
            <Text style={styles.textGray}>-</Text>
            <Text style={styles.textGray}>-</Text>
            <Text style={styles.textGray}>-</Text>
            <Text style={styles.textGray}>-</Text>
            <Text style={styles.textGray}>-</Text>
          </View>
        </View>

        {/* Condições e Observações */}
        <Text style={styles.conditionsRedText}>
          <Text style={styles.boldBlue}>Condições: </Text>
          Os preços da presente proposta só serão cadastrados no sistema após aceite do cliente por e-mail. O prazo de cadastro é de até 5 dias úteis. Os preços estarão válidos após confirmação do vendedor, CRC ou da portal Loja Virtual.
        </Text>

        <Text style={styles.textGray}>
          <Text style={styles.boldBlue}>Validade da Proposta: </Text>
          3 dias
        </Text>

        <Text style={styles.textGray}>
          <Text style={styles.boldBlue}>Observações: </Text>
          Descarga no cliente (CIF), com distância de até 10 metros em superfície plana e sem obstáculos. Em condição de riscos ou grandes distâncias o funcionário tem direito a recusa da descarga, ficando a obra responsável por esta. É obrigatória a devolução dos pallets. Entregas na{" "}
          <Text style={{ textDecoration: "underline" }}>ZMRC</Text> serão feitas no período noturno
        </Text>

        <Text style={styles.textGray}>
          <Text style={styles.boldBlue}>Programações: </Text>
          Pela CRC em 4003-9894, no site Loja Virtual https://loja.juntossomosmais.com.br/home
        </Text>

        <Text style={styles.textGray}>
          <Text style={styles.boldBlue}>Vendedor: </Text>
          {usuario?.nome || "Vendedor Não encontrado"}
        </Text>
      </View>
      <View style={styles.footerx}>
        <Image src={votorantimcimentos} style={{ width: 200 }} />
      </View>
    </Page>
  </Document>
);
